import type { Step } from "react-joyride";

export const documentPdfPreviewTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້າສະແດງຮູບແບບ PDF ເອກະສານ. ທ່ານສາມາດດາວໂຫຼດ ຫຼື ພິມເອກະສານນີ້ໄດ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="document-pdf-actions"]',
    content:
      "ກັບໄປຫນ້າລາຍລະອຽດເອກະສານ ຫຼື ພິມເອກະສານນີ້.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="document-pdf-content"]',
    content:
      "ຮູບແບບສະແດງເອກະສານຕາມທີ່ຈະພິມ ຫຼື ບັນທຶກເປັນ PDF.",
    placement: "top",
  },
];
